import { LOAD_PROJECTS, OPEN_PROJECTS_DIALOG, SET_ACTIVE_PROJECT } from '../actions/projectsActions';

const initialState = {
  projects: [],
  activeProject: null,
};

const projectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PROJECTS:
      return { ...state, projects: action.payload };
    case OPEN_PROJECTS_DIALOG:
      return { ...state, projects: action.payload };
    case SET_ACTIVE_PROJECT:
      return { ...state, activeProject: action.payload };
    default:
      return state;
  }
};

export default projectsReducer;
